var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('div',{staticClass:"pdf-container",attrs:{"id":"pdf-container"}},[_c('PdfDocument',{attrs:{"pdf-id":_vm.pdfId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }